import Axios from '@/utils/union-axios'

const urlPrefix = '/energy'

/**
 * 用户作为主使用人的车辆列表，只返回vin和vehicleTypeName
 */
export function getVehicleList() {
  return Axios.post(`${urlPrefix}/user/vehicle/list/all`)
}

/**
 * 获取用户作为主使用人的车辆列表，这里只查当前车控选中的VIN，返回单个车辆信息项的list
 */
export function getVehicleInfo(params: { vin: string }) {
  return Axios.post(`${urlPrefix}/user/vehicle/list`, params)
}

/**
 * 获取某个周期的能耗数据
 */
export function getWeekEnergyData(params) {
  return Axios.post(`${urlPrefix}/report/week/summary`, params)
}

/**
 * 获取日期列表
 */
export function getDatePreviewList(params) {
  return Axios.post(`${urlPrefix}/report/day/preview/list`, params)
}

/**
 * 获取单日能耗数据
 */
export function getSingleDayEnergyData(params) {
  return Axios.post(`${urlPrefix}/report/day/detail`, params)
}

/**
 * 获取单日行程数据
 */
export function getSingleDayDriveSectionList(params) {
  return Axios.post(`${urlPrefix}/report/day/driveSection/list`, params)
}